import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { LineChartHeader } from "./LineChartHeader";
import { LineChartCanvas } from "./LineChartCanvas";
import { useLineChartExport } from "./hooks/useLineChartExport";
import type { LineChartData } from "@/lib/chat/parseLineChartBlock";

interface LineChartModalProps {
  open: boolean;
  onClose: () => void;
  data: LineChartData;
}

export const LineChartModal: React.FC<LineChartModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useLineChartExport(exportRef, data.title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <div ref={exportRef} className="flex flex-col flex-1 min-h-0">
          <LineChartHeader
            title={data.title}
            mode="expanded"
            onDownload={exportPNG}
            onToggleExpand={onClose}
          />
          <div className="flex-1 min-h-0 bg-muted/20">
            <LineChartCanvas data={data} height="fill" mode="expanded" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
